import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import FotoOmarErrandi from '../assets/images/FotoOmarErrandi.jpeg';
function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper"> 
          <img src={FotoOmarErrandi} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">         
            <a href="https://www.linkedin.com/in/omar-errandi-a96ba7197/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Omar Errandi</h1>
          <p>Computer Science Engineer</p>

          <div className="mobile_social_icons">
            <a href="https://www.linkedin.com/in/omar-errandi-a96ba7197/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;